

export default {

  pdfContent: [],


  dd: {},

  makeConsent(signature, content, cb) {
    this.pdfContent = [
      {
        columns: [
          {
            text: content
          },
        ],
      },
      {
        image: signature,
        width: 200,
        height: 100,
        alignment: "right",
        style: "break",
      },
      {
        text:
          "___________________________________\n" +
          "Signature of Patient",
        bold: true,
        alignment: "right",
      },
    ];
    this.makeDocDefinition();
    cb();
  },
  makeDocDefinition() {
    this.dd = {
      pageMargins: [25, 120, 25, 120],
      content: this.pdfContent,
      styles: {
        "font-sm": {
          fontSize: 9,
        },
        "sub-header": {
          fontSize: 12,
          bold: false,
          alignment: "justify",
          margin: [0, 15],
          color: "black",
          background: "#EEE",
        },
        break: {
          margin: [0, 20],
        },
        "inner-top-break": {
          margin: [20, 10, 0, 0],
        },
        "inner-most-bottom-break": {
          margin: [40, 0, 0, 5],
        },
        "inner-bottom-sm-break": {
          margin: [20, 0, 0, 5],
        },
        "inner-bottom-break": {
          margin: [20, 0, 0, 10],
        },
        "small-break": {
          margin: [0, 10],
        },
        inner: {
          margin: [20, 0, 0, 0],
        },
        "inner-most": {
          margin: [40, 0, 0, 0],
        },
        "inner-n-small-break": {
          margin: [20, 10, 0, 0],
        },
        "inner-most-n-small-break": {
          margin: [40, 10, 0, 0],
        },
        "inner-n-break": {
          margin: [20, 20, 0, 0],
        },
        highlight: {
          background: "#EEE",
        },
        green: {
          color: "#0c8412",
        },
        orange: {
          color: "orange",
        },
      },
      defaultStyle: {
        font: "english",
      },
      header: {
        text: "Informed Consent",
        alignment: "center",
        fontSize: 16,
        bold: true,
      },
    };
  },
  async getDataURL(signature, content, cb) {

    let that = this

    this.makeConsent(signature, content, function () {
      var dataUrlHandle = pdfMake.createPdf(that.dd);

      dataUrlHandle.getDataUrl(function (data) {
        cb(data);
      });
    });

  }

}
